import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://swsqe10.softwisesol.com",
  withCredentials: true,
});
export default axiosInstance;
